import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

import { PHOSPHOR_ICON_NAMES, REITE_ICON_NAMES, SvgIconId } from './phosphor-icons';

/**
 * Register every `svgIcon` name the app can use.
 *
 * `addSvgIcon` only records a URL — nothing is fetched until a `<mat-icon>` asks for that name —
 * so registering the whole set costs nothing at startup, and the alternative (registering per
 * feature) fails silently: an unknown name renders as an empty box with only a console error.
 */
export function registerAppIcons(registry: MatIconRegistry, sanitizer: DomSanitizer): void {
  for (const name of PHOSPHOR_ICON_NAMES) {
    const id: SvgIconId = `ph-regular-${name}`;
    registry.addSvgIcon(
      id,
      sanitizer.bypassSecurityTrustResourceUrl(`assets/icons/phosphor/regular/${name}.svg`)
    );
  }

  for (const name of REITE_ICON_NAMES) {
    const id: SvgIconId = `reite-${name}`;
    registry.addSvgIcon(id, sanitizer.bypassSecurityTrustResourceUrl(`assets/icons/${name}.svg`));
  }
}
